module.exports = __webpack_public_path__ + "assets/logo-weclever-dark.f146b85a.svg";